import { ColorInput } from '../../../baseInputs/colorInput/ColorInput';

export const TextColorInput = ({ value, onChange }: { value?: string; onChange: (newValue?: string) => void }) => {
  return <ColorInput value={value} onChange={onChange} onlySolid defaultSwatchesTarget="text" />;
};
